export const DEFAULT_PAGINATION = {
  page: 1,
  perPage: 10,
  results: [],
  total: 0,
};
